(function () {
  const SELECTORS = {
    root: "[data-gift-note]",
    enable: "[data-gift-note-enable]",
    fields: "[data-gift-note-fields]",
    input: "[data-gift-note-input]",
    count: "[data-gift-note-count]",
    counter: "[data-gift-note-counter]",
    target: (id) => `[data-gift-note-target="${id}"]`,
    addToCart: "[data-add-to-cart]",
  };

  function getEls(root) {
    const id = root.dataset.giftNoteId;
    const scope = root.closest(".shopify-section") || document;
    return {
      root,
      id,
      enable: root.querySelector(SELECTORS.enable),
      fields: root.querySelector(SELECTORS.fields),
      input: root.querySelector(SELECTORS.input),
      count: root.querySelector(SELECTORS.count),
      counter: root.querySelector(SELECTORS.counter),
      target: scope.querySelector(SELECTORS.target(id)),
      required: root.dataset.giftNoteRequired === "true",
      max: Number(root.dataset.giftNoteMax || 0),
    };
  }

  function setTargetActive(target, value) {
    if (!target) return;
    const trimmed = value.trim();
    target.value = trimmed;
    // Only submit a property when there is real note text
    target.disabled = trimmed === "";
  }

  function sync(els, options) {
    const enabled = Boolean(els.enable && els.enable.checked);
    const wasOpen = els.root.classList.contains("is-open");

    els.root.classList.toggle("is-open", enabled);

    if (!enabled) {
      if (els.input) {
        els.input.value = "";
        els.input.required = false;
      }
      setTargetActive(els.target, "");
    } else {
      const value = els.input ? els.input.value : "";
      if (els.input) {
        els.input.required = els.required;
      }
      setTargetActive(els.target, value);

      if (!wasOpen && options && options.focus && els.input) {
        els.input.focus({ preventScroll: true });
      }
    }

    if (els.count && els.input) {
      const length = els.input.value.length;
      els.count.textContent = String(length);

      if (els.counter && els.max > 0) {
        els.counter.classList.toggle("is-near-limit", length / els.max >= 0.9);
      }
    }
  }

  function initRoot(root) {
    if (root.dataset.giftNoteReady === "true") return;
    root.dataset.giftNoteReady = "true";

    const els = getEls(root);
    if (!els.enable || !els.input) {
      // Still keep any matching form field from submitting empty properties
      if (els.target) setTargetActive(els.target, "");
      return;
    }

    sync(els);

    els.enable.addEventListener("change", () => sync(els, { focus: true }));
    els.input.addEventListener("input", () => sync(els));
    els.input.addEventListener("change", () => sync(els));

    const form = els.target && els.target.closest("form");
    const beforeSubmit = (event) => {
      sync(els);

      if (!els.enable.checked) return;
      if (els.required && !els.input.value.trim()) {
        event.preventDefault();
        els.input.reportValidity();
      }
    };

    if (form) {
      form.addEventListener("submit", beforeSubmit);
    }

    const section = root.closest(".shopify-section") || document;
    section.querySelectorAll(SELECTORS.addToCart).forEach((button) => {
      button.addEventListener("click", beforeSubmit);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SELECTORS.root).forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
  });
})();
